export const selectAllHandler = (
  data,
  name,
  isLocationSelected,
  isSpecificLocationSelected,
  isAllSelected,
) => {
  const select = !isAllSelected;

  const locationArr = isLocationSelected.map((location) => select);
  const locationDispatchObj = {
    controller: name,
    arr: locationArr,
  };
  const specificLocationArr = isSpecificLocationSelected.map((el) =>
    el.map((specLocationState) => select),
  );
  const specLocationDispatchObj = {
    controller: name,
    arr: specificLocationArr,
  };

  const individualArr = Object.values(data)?.map((location, i) => {
    if (location.isSpecificLocation) {
      return Object.values(location.subLocations).map((subLocation) => {
        Object.values(subLocation.devices).map((machine) => {
          return select;
        });
      });
    } else {
      return Object.values(location.devices).map((machine) => {
        return select;
      });
    }
  });

  const machineDispatchObj = {
    controller: name,
    arr: individualArr,
  };
  return {
    locationList: locationDispatchObj,
    specificLocationList: specLocationDispatchObj,
    machineList: machineDispatchObj,
    select,
  };
};
